<template>
  <div class="h-100 ma-3">
    <v-main class="h-100" :scrollable="$vuetify.display.xs">
      <div class="h-100">
        <slot></slot>

        <div class="head-login-block">
          <p>
            Pieslēdzies platformai Soma, lai pildītu uzdevumus un sekotu līdzi rezultātiem!
          </p>
          <button class="login-button" style="border:0 !important;" @click.stop.prevent="clickLoginButton">
            <span class="content"><svg-arrow-right-to-bracket></svg-arrow-right-to-bracket> <span>Pieslēgties</span></span>
          </button>
        </div>

        <div class="smart-page-preview-footer">
          <hr />
          <div class="logo-block">
            <div class="soma-logo align-center justify-center">
              <span class="d-flex align-center">
                <v-icon icon="custom:somaLogo" :size="40" />
                <p>Soma</p>
              </span>
            </div>
          </div>
          <p class="footer-text">
            Mācību platforma Soma<br />
            Lielvārds &copy; 2025
          </p>
        </div>
      </div>
    </v-main>

    <LayoutSnackBar />
  </div>
</template>

<script lang="ts">
import { defineComponent } from "vue"

export default defineComponent({
  methods: {
    clickLoginButton() {
      this.$router.push("/login")
    }
  }
})
</script>

<style lang="sass" scoped>
@use "~/assets/css/vuetify/settings" as *

.head-login-block
  position: fixed
  top: 38px
  right: 38px
  width: 275px
  border: 1px solid rgba(0, 0, 0, 0.06)
  background: rgba(255, 255, 255, 0.7)
  padding: 20px
  backdrop-filter: blur(8px)
  -webkit-backdrop-filter: blur(8px)
  letter-spacing: 0.25px
  border-radius: 16px
  font-family: "CastleDownPro"
  color: #000000
  font-size: 14px
  line-height: 20px
  text-align: center

  p
    margin-bottom: 10px

  @media #{map-get($display-breakpoints, 'xs')}
    position: absolute
    left: 38px
    width: auto
    background: rgba(255, 255, 255, 0.95)

  .login-button
    cursor: pointer
    background-color: #f9d805
    display: inline-block
    padding: 15px
    border-radius: 25px
    font-weight: 700
    font-family: "CastleDownPro"
    font-size: 16px
    letter-spacing: 0.1px
    line-height: 20px
    color: #000000
    vertical-align: top
    text-decoration: none

    .content
      display: flex
      align-items: center
      justify-content: center

      svg
        margin-right: 8px

.smart-page-preview-footer
    hr
      border: none
      border-top: 1px solid #e0e0e0
      margin-bottom: 30px

    .logo-block
      display: flex
      align-items: center
      justify-content: center
      margin-bottom: 15px

    .footer-text
      font-size: 14px
      line-height: 20px
      font-family: "CastleDownPro"
      font-weight: 400
      color: #adadad

    background: white
    padding: 0 30px 30px 30px
    text-align: center
</style>
